import type { EventingContext } from '../types/context';

/**
 * Explicit missing value for experiment and bot. This matches the request
 * context contract's unknown token. It is never rewritten to `control`.
 */
export const EVENT_REQUEST_CONTEXT_UNKNOWN = 'unknown';

export interface ResolvedEventingContext extends EventingContext {
  readonly experiment: string;
  readonly bot: string;
}

function presentFact(value: string | undefined): string {
  if (typeof value !== 'string') {
    return EVENT_REQUEST_CONTEXT_UNKNOWN;
  }
  const trimmed = value.trim();
  return trimmed.length === 0 ? EVENT_REQUEST_CONTEXT_UNKNOWN : trimmed;
}

/**
 * Stamps experiment and bot onto the context used at the capture point.
 * The host supplies the snapshot values. A missing snapshot is unknown, and
 * the event is still sent. This does not read headers, cookies, or partner
 * fields such as arm or bot score.
 */
export function resolveEventRequestContext(
  context: EventingContext = {},
): ResolvedEventingContext {
  return {
    ...(context.correlationId ? { correlationId: context.correlationId } : {}),
    ...(context.pageUrl ? { pageUrl: context.pageUrl } : {}),
    ...(context.tenantId ? { tenantId: context.tenantId } : {}),
    experiment: presentFact(context.experiment),
    bot: presentFact(context.bot),
  };
}
